import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ParcelService } from '../../shared/services/parcel.service';
import { MessageService } from 'primeng/api';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-parcel-summary',
  templateUrl: './parcel-summary.component.html',
  styleUrls: ['./parcel-summary.component.scss'],
  standalone:true,
  imports:[...PRIMENG_MODULES, PopoverModule],
  providers:[MessageService]
})

export class ParcelSummaryComponent {
  @Input() inlineView: boolean = false;
  isLoading: boolean = false;
  summary: any = {};
  showSummaryPopover: boolean = false;

  constructor(private parcelService: ParcelService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.loadSummary();
   }


  loadSummary() {
    this.isLoading = true;
    this.parcelService.getParcelSummary().subscribe({
      next: (result) => {
        this.isLoading = false;
        this.summary = result.summary;
      },
      error: (err) => {
        this.isLoading = false;      
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Summery not found in DIA.' });
        console.error(err);
      }
    });
  }

  togglePopover(event: any) {
    if (!this.showSummaryPopover) {
      this.loadSummary();
    }
    this.showSummaryPopover = !this.showSummaryPopover;
  }

}
